<template>
  <DefaultLayout>
    <template slot="center">
      <div class="d-flex bg-white chat-container" :class="{toggled}">
        <div class="left">
          <div class="d-flex align-items-center chat-head">
            <input type="text" v-model="query" placeholder="Rechercher un utilisateur" class="form-control">
            <i class="ti-close cursor-pointer d-block d-md-none" @click="toggle"></i>
          </div>
          <div class="chats" v-if="!query">
            <div class="chat-title">Contacts</div>
            <div class="item" v-for="(user,i) in contacts" :key="i" @click="setActive(user)"
                 :class="{active: user===active}">
              <img :src="user.avatar" alt="" class="avatar">
              <span class="name">{{ user.full_name }}</span>
              <time v-if="user.last_date">{{ moment(user.last_date).format('HH:mm') }}</time>
            </div>
          </div>
          <div class="chats results" v-if="query">
            <div class="loader" style="height: 100px" v-if="searching"></div>
            <div v-else class="item" v-for="(user,i) in results" :key="i" @click="set(user)">
              <img :src="user.avatar" alt="" class="avatar">
              <span class="name">{{ user.full_name }}</span>
            </div>
            <p class="text-center mt-5" v-if="!searching && query.length>=2 && results.length===0">
              Aucun résultat disponible
            </p>
          </div>
        </div>
        <chat-widget show-loader visible class="chat-widget" :presence="false" :has-title="false" :with-shadow="false"
                     :user="active" @toggle="toggle"/>
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import ChatWidget from "@/components/Chat/ChatWidget";
import DefaultLayout from "@/Layout/DefaultLayout";
import {mapGetters} from "vuex";
import _ from "lodash";
import axios from "axios";
import moment from 'moment'

export default {
  name: "UserChat",
  components: {DefaultLayout, ChatWidget},
  data() {
    return {
      query: '',
      results: [],
      searching: false,
      active: null,
      toggled: true
    }
  },
  watch: {
    query: _.debounce(function (newVal) {
      // ne pas faire la recherche si le champ ne contient pas au moins 2 caractères et n'est pas vide
      if (newVal.length < 2) {
        this.results = []
        return
      }
      this.search()
    }, 300),
  },
  computed: {
    ...mapGetters({me: 'user', 'users': 'chat/users'}),
    contacts() {
      return _.orderBy(this.users, (u) => moment(u.last_date).unix(), 'desc')
    }
  },
  methods: {
    moment,
    toggle() {
      this.toggled = !this.toggled
    },
    setActive(user) {
      this.active = user
      this.query = ''
      this.toggle()
    },
    set(user) {
      const u = this.users.find(u => u.id === user.id)
      this.setActive(u || user)
    },
    search() {
      this.searching = true
      const base = axios.defaults.baseURL.replace('/api/student', '/api')
      axios.get('/user/search', {params: {search: this.query}, baseURL: base})
        .then(({data}) => {
          this.results = data.filter(u => u.id !== this.me.id)
        })
        .finally(() => this.searching = false)
    }
  },
  mounted() {
    this.$store.dispatch('chat/fetchContacts')
  }
}
</script>

<style lang="scss" scoped>

.chat-container {
  min-height: calc(100vh - 150px);

  @include down(768) {
    &.toggled {
      .chat-widget {
        display: none !important;
      }

      .left {
        width: 100%;
        display: block !important;
      }
    }

    .chat-widget {
      display: flex !important;
      width: 100%;
    }

    .left {
      display: none !important;
    }
  }

  .chat-widget {
    flex-grow: 1;
  }

  .left {
    border-right: 1px solid $gray;
    width: 30%;

    .chat-head {
      border-bottom: 1px solid $gray;
      height: 60px;
      @include gap-items-x(5px);
    }

    .chat-head, .chats .item {
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .chats {
      height: calc(100% - 60px);
      max-height: calc(100vh - 200px);
      overflow-y: auto;

      .chat-title {
        color: $green;
        padding: 10px;
      }

      .item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid $gray;
        cursor: pointer;

        &:hover, &.active {
          background-color: $gray;
        }

        @include gap-items-x(5px);

        .name {
          @include no-break();
          flex-grow: 1;
        }

        time {
          flex: 0 0 35px;
          font-size: 12px;
        }
      }
    }
  }
}


</style>
